"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkipBackward = exports.SkipForward = void 0;

var react_1 = __importDefault(require("react"));

var icons_1 = require("../../../icons");

var Tooltip_1 = require("../../ant/Tooltip");

var MediaPlaybackContext_1 = require("../MediaPlaybackContext");

var styled_1 = require("../styled");

var DELTA = 10;

function SkipForward(_ref) {
  var compact = _ref.compact;

  var _ref2 = (0, MediaPlaybackContext_1.useMediaPlaybackContext)(),
      duration = _ref2.duration,
      onSeek = _ref2.onSeek,
      playedSeconds = _ref2.playedSeconds,
      allowSeek = _ref2.allowSeek;

  if (duration && allowSeek) {
    return react_1.default.createElement(Tooltip_1.Tooltip, {
      title: 'Skip forward 10 seconds',
      mouseEnterDelay: 1
    }, react_1.default.createElement(styled_1.ControlContainer, {
      compact: compact !== undefined,
      onClick: function onClick() {
        return onSeek(Math.min(playedSeconds + DELTA, duration));
      }
    }, react_1.default.createElement(icons_1.SkipNextOutline, null)));
  } else {
    return null;
  }
}

exports.SkipForward = SkipForward;

function SkipBackward(_ref3) {
  var compact = _ref3.compact;

  var _ref4 = (0, MediaPlaybackContext_1.useMediaPlaybackContext)(),
      duration = _ref4.duration,
      onSeek = _ref4.onSeek,
      playedSeconds = _ref4.playedSeconds;

  if (duration) {
    return react_1.default.createElement(Tooltip_1.Tooltip, {
      title: 'Skip backward 10 seconds',
      mouseEnterDelay: 1
    }, react_1.default.createElement(styled_1.ControlContainer, {
      compact: compact !== undefined,
      onClick: function onClick() {
        return onSeek(Math.max(playedSeconds - DELTA, 0));
      }
    }, react_1.default.createElement(icons_1.SkipPrevOutline, null)));
  } else {
    return null;
  }
}

exports.SkipBackward = SkipBackward;